<template>

</template>

<script>


  import Vue from 'vue'
  import miniToastr from 'mini-toastr'
  import {setup, PrintPallet} from '../../assets/js/printFunctions.js'

  Vue.use(miniToastr);

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }






  export default {
    name: 'reusablePrintContent',
    created() {


    },
    data() {

      return {

      }
    },
    methods: {
      printLabel(pallet_id, quantity, type) {
          this.$axios('/api/v1/pallet/'+pallet_id+'/pallet_print/')
            .then( res => {
                PrintPallet(res.data, quantity, type);
                miniToastr.success("Operación realizada con éxito", "");
              }
            )
            .catch(error => { miniToastr.error("Ha ocurrido un error.", "");});
      },
  },
  mounted()
  {
    setup();
  }
  }

</script>
<style>
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    /*display: inline-block;*/
    /*width: 100%;*/
    min-height: calc(1.5em + 0.75rem + 2px);
    /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
    font-size: 0.6875rem;
    font-weight: 400;
    /*line-height: 1.5;*/
    color: #5c6873;
    /*vertical-align: middle;*/
    /*background-color: #fff;*/
    border: 1px solid #e4e7ea;
    /*border-radius: 0.25rem;*/
    /*-webkit-appearance: none;*/

  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }


  img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
  }

  .d-center {
    display: flex;
    align-items: center;
  }

  .selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
  }

  .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active > a {
    color: #fff;
  }


</style>
